export default {
    filters: {
        firstChar(val, from = null) {
            if (!isNaN(from)) {
                return val.charAt(from)
            }
            return val.charAt(0)
        }
    }
}